import { Headline, IconButton, Loading } from '@folio/stripes/components';
import classNames from 'classnames';
import React from 'react';
import { FormattedDate, useIntl } from 'react-intl';
import { getDateArray } from '../utils/CalendarUtils';
import { dateUTCToYYYYMMDD, isSameUTCMonth } from '../utils/DateUtils';
import { useLocaleWeekdays } from '../utils/WeekdayUtils';
import css from './Calendar.css';
export function getWeekdayLabels(localeWeekdays) {
    return localeWeekdays.map(function (w, i) { return (React.createElement("div", { key: i, className: css.weekdayLabel },
        React.createElement("span", null, w.short))); });
}
export default function Calendar(props) {
    var monthBasis = props.monthBasis, setMonthBasis = props.setMonthBasis, events = props.events;
    var intl = useIntl();
    var localeWeekdays = useLocaleWeekdays(intl);
    var displayDates = getDateArray(intl.locale, monthBasis).map(function (date) {
        var dateString = dateUTCToYYYYMMDD(date);
        var contents = React.createElement(Loading, null);
        if (dateString in events) {
            contents = events[dateString];
        }
        return (React.createElement("div", { className: classNames(isSameUTCMonth(date, monthBasis) ? '' : css.adjacentMonth, css.calendarDay), key: dateUTCToYYYYMMDD(date) },
            React.createElement("span", { key: "label", className: css.dayLabel },
                React.createElement(FormattedDate, { value: date, day: "numeric", timeZone: "UTC" })),
            contents));
    });
    return (React.createElement("div", { className: css.calendar, style: {
            '--num-main-cal-rows': displayDates.length / 7
        } },
        React.createElement("div", { key: "header", className: css.headerRow },
            React.createElement(IconButton, { icon: "arrow-left", onClick: function () { return setMonthBasis(new Date(new Date(monthBasis).setUTCMonth(monthBasis.getUTCMonth() - 1))); } }),
            React.createElement(Headline, { size: "xx-large", margin: "none" },
                React.createElement(FormattedDate, { value: monthBasis, month: "long", year: "numeric", timeZone: "UTC" })),
            React.createElement(IconButton, { icon: "arrow-right", onClick: function () { return setMonthBasis(new Date(new Date(monthBasis).setUTCMonth(monthBasis.getUTCMonth() + 1))); } })),
        getWeekdayLabels(localeWeekdays),
        displayDates));
}
